<template>
    <div class="edit-box">
        <!-- 文本展示 -->
        <div v-if="!isShowEditor" class="personalCenter__editInfo personalCenter__Info">
            <div class="personalCenter__content_Detailinfo  personalCenter__content_editInfo">
                <div class="personal-center-header">
                  <h3>个人信息</h3>
                  <p v-if="userInfo.infoIntegrity < 100">请务必填写以下信息获得船票预订积分和会员专属福利，现在完善信息还能额外获赠200积分奖励。</p>
                </div>
                <div class="privacy-layout" :class="{'is-left': userInfo.infoIntegrity >= 100}">
                  <privacy-button @privacy-switch="reload" type="text-mini"></privacy-button>
                </div>
                <div class="personalCenter__input__row">
                  <div class="input__row_container">
                    <div class="txtCon">
                      <p class="personalCenter__smalltxt">国家/地区</p>
                    </div>
                    <div class="inputCon">
                      <span>{{userInfo.nationality}}</span>
                    </div>
                  </div>
                </div>
                <div class="personalCenter__input__row">
                    <div class="input__row_container">
                        <div class="txtCon">
                            <p class="personalCenter__smalltxt">中文姓</p>
                        </div>
                        <div class="inputCon">
                            <span>{{userInfo.lastName}}</span>
                        </div>
                    </div>
                    <div class="div--verticalLine"></div>
                    <div class="input__row_container">
                        <div class="txtCon">
                            <p class="personalCenter__smalltxt">中文名</p>
                        </div>
                        <div class="inputCon">
                            <span>{{userInfo.firstName}}</span>
                        </div>
                    </div>
                </div>
                <div class="personalCenter__input__row">
                    <div class="input__row_container">
                        <div class="txtCon">
                            <p class="personalCenter__smalltxt">姓拼音</p>
                        </div>
                        <div class="inputCon">
                            <span>{{userInfo.lastNamePinYin}}</span>
                        </div>
                    </div>
                    <div class="div--verticalLine"></div>
                    <div class="input__row_container">
                        <div class="txtCon">
                            <p class="personalCenter__smalltxt">名拼音</p>
                        </div>
                        <div class="inputCon">
                            <span>{{userInfo.firstNamePinYin}}</span>
                        </div>
                    </div>
                </div>
                <div class="personalCenter__input__row">
                    <div class="input__row_container">
                        <div class="txtCon">
                            <p class="personalCenter__smalltxt">性别</p>
                        </div>
                        <div class="inputCon">
                            <span>{{ userInfo.gender === 'M' ? '男' : (userInfo.gender === 'F' ? '女' : '未知') }}</span>
                        </div>
                        <div class="div--verticalLine" style="top:10px;"></div>
                    </div>
                    <div class="div--verticalLine"></div>
                    <div class="input__row_container">
                        <div class="txtCon">
                            <p class="personalCenter__smalltxt">出生日期</p>
                        </div>
                        <div class="inputCon">
                            <span>{{userInfo.dateOfBirthStr}}</span>
                        </div>
                    </div>
                </div>
                <div class="personalCenter__input__row">
                    <div class="input__row_container">
                        <div class="txtCon">
                            <p class="personalCenter__smalltxt">手机号</p>
                        </div>
                        <div class="inputCon">
                            <span>{{userInfo.mobile}}</span>
                        </div>
                    </div>
                    <div class="div--verticalLine"></div>
                    <div class="input__row_container">
                        <div class="txtCon">
                            <p class="personalCenter__smalltxt">电子邮箱</p>
                        </div>
                        <div class="inputCon">
                            <span>{{userInfo.email}}</span>
                        </div>
                    </div>
                </div>
                <div class="personalCenter__editInfo_button">
                    <div class="personalCenter__button_editBtn">
                        <button class="editInfo__editBtn" @click="showEditor">编辑</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 编辑 -->
        <div v-if="isShowEditor" class="personalCenter__editInfo" @click="closeSelectNationalityLayer">
            <div class="personalCenter__content_Detailinfo  personalCenter__content_editInfo">
                <div class="personal-center-header">
                  <h3>个人信息</h3>
                  <p v-if="userInfo.infoIntegrity < 100">请务必填写以下信息获得船票预订积分和会员专属福利，现在完善信息还能额外获赠200积分奖励。</p>
                </div>
                <div class="privacy-layout" :class="{'is-left': userInfo.infoIntegrity >= 100}">
                  <privacy-button @privacy-switch="reload" type="text-mini"></privacy-button>
                </div>
                <div class="personalCenter__input__row">
                  <div class="input__row_container">
                    <div class="txtCon">
                      <p class="personalCenter__smalltxt">国家/地区</p>
                    </div>
                    <div class="inputCon">
                      <input
                          v-model="userInfo.nationality"
                          type="text"
                          maxlength="10"
                          class="editInfo_nationality"
                          id="editInfoNationality"
                          name="Nationality"
                          data-key="Nationality"
                          readonly
                          placeholder="必填"
                          @click.stop="selectNationalityLayer"
                      >
                    </div>
                    <div v-if="isShowNationalityOption" id="countrySelCon" class="countrySelCon">
                      <a
                          v-for="item in userInfo.nationalityApiViews"
                          :key="item.id"
                          :data-country="item.countryCode"
                          @click="selectNationality(item)"
                      >
                        {{item.countryName}}
                      </a>
                    </div>
                  </div>
                </div>
                <div class="personalCenter__input__row">
                    <div class="input__row_container">
                        <div class="txtCon">
                            <p class="personalCenter__smalltxt">中文姓</p>
                        </div>
                        <div class="inputCon">
                            <input
                                v-model="userInfo.lastName"
                                type="text"
                                maxlength="4"
                                class="surname--chinese"
                                name="LastName"
                                data-key="LastName"
                                :placeholder="isNeed"
                                @change="handlerLastName"
                                @focus="txtFocus"
                                :class="{'no-bc': !userInfo.customerEditable.canLastNameEdit}"
                                :disabled="!userInfo.customerEditable.canLastNameEdit"
                            >
                        </div>
                    </div>
                    <div class="div--verticalLine"></div>
                    <div class="input__row_container">
                        <div class="txtCon">
                            <p class="personalCenter__smalltxt">中文名</p>
                        </div>
                        <div class="inputCon">
                            <input
                                v-model="userInfo.firstName"
                                type="text"
                                maxlength="4"
                                class="name--chinese"
                                name="FirstName"
                                data-key="FirstName"
                                :placeholder="isNeed"
                                @change="handlerFirstName"
                                @focus="txtFocus"
                                :class="{'no-bc': !userInfo.customerEditable.canFirstNameEdit}"
                                :disabled="!userInfo.customerEditable.canFirstNameEdit"
                            >
                        </div>
                    </div>
                </div>
                <div class="personalCenter__input__row">
                    <div class="input__row_container">
                        <div class="txtCon">
                            <p class="personalCenter__smalltxt">姓拼音</p>
                        </div>
                        <div class="inputCon">
                            <input
                                v-model="userInfo.lastNamePinYin"
                                type="text"
                                maxlength="20"
                                class="surname--spell"
                                name="LastNamePinYin"
                                data-key="LastNamePinYin"
                                :placeholder="`必填${isRow ? '(last name)' : ''}`"
                                @focus="txtFocus"
                                :class="{'no-bc': !userInfo.customerEditable.canLastNamePingyinEdit}"
                                :disabled="!userInfo.customerEditable.canLastNamePingyinEdit"
                            >
                        </div>
                    </div>
                    <div class="div--verticalLine"></div>
                    <div class="input__row_container">
                        <div class="txtCon">
                            <p class="personalCenter__smalltxt">名拼音</p>
                        </div>
                        <div class="inputCon">
                            <input
                                v-model="userInfo.firstNamePinYin"
                                type="text"
                                maxlength="30"
                                class="name--spell"
                                name="FirstNamePinYin"
                                data-key="FirstNamePinYin"
                                :placeholder="`必填${isRow ? '(first name)' : ''}`"
                                @focus="txtFocus"
                                :class="{'no-bc': !userInfo.customerEditable.canFirstNamePingyinEdit}"
                                :disabled="!userInfo.customerEditable.canFirstNamePingyinEdit"
                            >
                        </div>
                    </div>
                </div>
                <div class="personalCenter__input__row">
                    <div class="input__row_container">
                        <div class="txtCon">
                            <p class="personalCenter__smalltxt">性别</p>
                        </div>
                        <div class="inputCon">
                            <label class="sex customRadioContainer">
                                男
                                <input
                                    type="radio"
                                    class="gender-male guestFormInput"
                                    name="gender"
                                    data-key="Gender"
                                    :checked="userInfo.gender === 'M'"
                                    @click="checkGender('M')"
                                >
                                <span class="checkmark"></span>
                            </label>
                            <label class="sex famale customRadioContainer">
                                女
                                <input
                                    type="radio"
                                    class="gender-female guestFormInput"
                                    name="gender"
                                    data-key="Gender"
                                    :checked="userInfo.gender === 'F'"
                                    @click="checkGender('F')"
                                >
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <div class="div--verticalLine" style="top:10px;"></div>
                    </div>
                    <div class="div--verticalLine"></div>
                    <div class="input__row_container">
                        <div class="txtCon">
                            <p class="personalCenter__smalltxt">出生日期</p>
                        </div>
                        <div class="inputCon">
                            <input
                                type="text"
                                style="width:85%;"
                                name="DateOfBirth"
                                data-key="DateOfBirth"
                                class="DateOfBirth"
                                v-model="userInfo.dateOfBirthStr"
                                readonly
                                placeholder="必填"
                                @click="selectBirthDate"
                                @focus="txtFocus"
                                :class="{'no-bc': !userInfo.customerEditable.canDateOfBirthEdit}"
                                :disabled="!userInfo.customerEditable.canDateOfBirthEdit"
                            >
                        </div>
                        <!-- 日历控件 -->
                        <div v-if="isShowBirthCalender" class="calender-container date-birth-calender">
                            <rccl-calendar
                                :defaultDate="userInfo.dateOfBirthStr"
                                :allowPreYear="true"
                                @onDateClicked="handleBirthDate"
                            ></rccl-calendar>
                        </div>
                    </div>
                </div>
                <div class="personalCenter__input__row">
                    <div class="input__row_container">
                        <div class="txtCon">
                            <p class="personalCenter__smalltxt">手机号</p>
                        </div>
                        <div class="inputCon">
                            <input
                                v-model="userInfo.mobile"
                                type="text"
                                class="editInfo_phone"
                                name="Mobile"
                                data-key="Mobile"
                                style="border:none;"
                                readonly
                                disabled
                            >
                        </div>
                    </div>
                    <div class="div--verticalLine"></div>
                    <div class="input__row_container">
                        <div class="txtCon">
                            <p class="personalCenter__smalltxt">电子邮箱</p>
                        </div>
                        <div class="inputCon">
                            <input
                                v-model="userInfo.email"
                                type="text"
                                class="editInfo_email"
                                maxlength="30"
                                name="Email"
                                data-key="Email"
                                placeholder="必填"
                                @focus="txtFocus"
                            >
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-footer-box">
              <div class="chk-box">
                <RcclCheckBox :defaultChecked="userInfo.marketingFlagEmail" v-on:onChanged="marketingFlagEmailChange" />
                <div>我同意<span class="is-important">电子邮箱</span>接受皇家加勒比品牌资讯及优惠信息</div>
              </div>
              <div v-if="canGetReward" class="improvePointsPromptsBar">
                <img class="promptsIcon" :src="`${imgUrl}/global/icons/pointsYellow.png`" alt="" />
                <div class="promptsText">
                  填写完以上信息将获得<span class="txt">200</span>积分
                </div>
              </div>
            </div>
            <div class="personalCenter__editInfo_button">
                <div class="personalCenter__button_cancelBtn">
                    <button class="editInfo__cancelBtn" @click="cancelSubmit">{{cancelBtnText}}</button>
                </div>
                <div class="personalCenter__button_saveBtn">
                    <button class="editInfo__saveBtn" @click="submitInfo">确认</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '@/api'
    import RcclCalendar from '@/components/Common/RcclCalendar'
    import PrivacyButton from "@/components/Common/PrivacyButton";
    import { isChinese, isLetter, checkMail } from '@/utilities/tools'
    const RcclCheckBox = () => import("@/components/Common/RcclCheckBox");
    export default {
        name: 'EditUserInfo',
        components: {
            RcclCalendar,
            PrivacyButton,
            RcclCheckBox
        },
        props: {
          isMaskValue: {
            type: Boolean,
            default: true
          }
        },
        data: () => {
            return {
                imgUrl: process.env.VUE_APP_IMG_URL,
                isShowEditor: false,
                token: '',
                userInfo: {},
                userInfoOriginal: {},
                isRow: 0, // 0中国   1国外  默认中国
                isNeed: '必填',
                isShowBirthCalender: false,
                isShowNationalityOption: false,
                countyList: [],
                cancelBtnText: '取消',
                updateFields: []
            }
        },
        watch: {
            isRow (newVal) {
                if (newVal) this.isNeed = '选填'
                else this.isNeed = '必填'
            }
        },
        computed: {
          canGetReward() {
            let userInfo = this.$store.state.user.userInfo;
            let isLocalReward = userInfo && userInfo?.userIdentity && userInfo.userIdentity === 1
            console.log(userInfo.infoIntegrity)
            return isLocalReward && userInfo.infoIntegrity < 100;
          },
        },
        beforeMount () {
            this.init()
        },
        methods: {
            async init () {
                this.$loading.show()
                await this.initPage()
                this.$loading.hide()
            },
            async initPage () {
                this.token = this.$store.state.user.userToken
                this.userInfo = await this.getUserInfo(this.token)
                this.userInfoOriginal = Object.assign({},this.userInfo)
                this.isRow = (!this.userInfo.nationality || this.userInfo.nationality === '中国') ? 0 : 1
                this.cancelBtnText = this.userInfo.infoIntegrity < 100 ? '稍后完善' : '取消'
            },
            checkGender (gender) {
                this.userInfo.gender = gender
                // let user = this.userInfo;
                // let userOriginal = this.userInfoOriginal;
                if(!this.updateFields.includes('Gender')) {
                  this.updateFields.push("Gender")
                }
            },
            showEditor () {
                this.isShowEditor = true
            },
            async handlerLastName () {
                if (!this.userInfo.lastName || this.userInfo.lastName.length == 0) {
                    return
                }
                const data = await this.getPinYin(this.userInfo.lastName)
                if (!data || data.length == 0) return
                this.userInfo.lastNamePinYin = data
            },
            async handlerFirstName () {
                if (!this.userInfo.firstName || this.userInfo.firstName.length == 0) {
                    return
                }
                const data = await this.getPinYin(this.userInfo.firstName)
                if (!data || data.length == 0) return
                this.userInfo.firstNamePinYin = data
            },
            selectBirthDate () {
                // if (this.userInfo.dateOfBirthStr) return false
                this.isShowBirthCalender = true
            },
            handleBirthDate (date) {
                if (date) this.userInfo.dateOfBirthStr = date
                this.isShowBirthCalender = false
            },
            selectNationalityLayer () {
                this.isShowNationalityOption = true
            },
            closeSelectNationalityLayer () {
                this.isShowNationalityOption = false
            },
            selectNationality (item) {
                if (item.countryName === '中国') this.isRow = 0
                else this.isRow = 1
                this.userInfo.nationality = item.countryName
                this.isShowNationalityOption = false
                if(!this.updateFields.includes('Nationality')) {
                  this.updateFields.push('Nationality')
                }
            },
            cancelSubmit () {
                const self = this
                if (this.userInfo.infoIntegrity < 100) {
                    this.$confirm.show('完善信息后积分方可累计，是否继续完善？', {
                        cancelCallBack: ()=> {
                        //   self.cancelSubmitApi()
                        // 点击取消不保存用户信息
                        self.goBack()
                        }
                    })
                } else {
                    // self.cancelSubmitApi()
                    // 不保存个人信息
                    self.goBack()
                }
            },
            async cancelSubmitApi () {
                this.$loading.show()
                this.subEditInfo()
                    .then(res => {
                        this.$loading.hide()
                        if (res.success) {
                            return this.goBack()
                        } else {
                            this.$alert.show(res.errMsg)
                        }
                    })
                    .catch(err => {
                        this.$loading.hide()
                        this.$alert.show(err)
                    })
            },
            async submitInfo () {
                if(this.updateFields.length === 0) {
                  this.$alert.show('没有任何修改')
                  return false
                }
                if (!this.userInfo.gender) {
                    this.$alert.show('性别必填')
                    return false
                }
                if (this.isRow === 0 && !this.userInfo.lastName) {
                    this.$alert.show('请输入中文姓')
                    return false
                }
                if (this.isRow === 0 && !this.userInfo.firstName) {
                    this.$alert.show('请输入中文名')
                    return false
                }

                if(!this.isMaskValue || this.updateFields.includes("LastName")) {
                  if (!isChinese(this.userInfo.lastName)) {
                    this.$alert.show('请输入正确的中文姓或中文名')
                    return false
                  }
                }

                if(!this.isMaskValue || this.updateFields.includes("FirstName")) {
                  if (!isChinese(this.userInfo.firstName)) {
                    this.$alert.show('请输入正确的中文姓或中文名')
                    return false
                  }
                }

                // if (this.isRow === 0 && (!isChinese(this.userInfo.lastName) || !isChinese(this.userInfo.firstName))) {
                //     this.$alert.show('请输入正确的中文姓或中文名')
                //     return false
                // }

                if (!this.userInfo.lastNamePinYin) {
                    this.$alert.show('请输入拼音姓')
                    return false
                }
                if (!this.userInfo.firstNamePinYin) {
                    this.$alert.show('请输入拼音名')
                    return false
                }

                if (!this.isMaskValue) {
                  if(this.updateFields.includes('LastName')) {
                    this.updateFields.push('LastNamePinYin')
                  }
                  if(this.updateFields.includes('FirstName')) {
                    this.updateFields.push('FirstNamePinYin')
                  }
                }

                if(!this.isMaskValue || this.updateFields.includes("LastNamePinYin")) {
                  if (!isLetter(this.userInfo.lastNamePinYin)) {
                    this.$alert.show('请输入正确的拼音姓或拼音名')
                    return false
                  }
                }
                if(!this.isMaskValue || this.updateFields.includes("FirstNamePinYin")) {
                  if (!isLetter(this.userInfo.firstNamePinYin)) {
                    this.$alert.show('请输入正确的拼音姓或拼音名')
                    return false
                  }
                }
                // if (!isLetter(this.userInfo.lastNamePinYin) || !isLetter(this.userInfo.firstNamePinYin)) {
                //     this.$alert.show('请输入正确的拼音姓或拼音名')
                //     return false
                // }

                if (!this.userInfo.dateOfBirthStr) {
                    this.$alert.show('请输入出生日期')
                    return false
                }

                if (!this.userInfo.email) {
                    this.$alert.show('请输入邮箱')
                    return false
                }

                if(!this.isMaskValue || this.updateFields.includes("Email")) {
                  if (this.userInfo.email && this.userInfo.email.length > 0 && !checkMail(this.userInfo.email)) {
                    this.$alert.show('请输入正确的邮箱');
                    return false;
                  }
                }

                if (!this.userInfo.nationality) {
                    this.$alert.show('请选择国籍')
                    return false
                }

                // 提交数据
                this.$loading.show()
                this.subEditInfo()
                    .then(res => {
                        this.$loading.hide()
                        if (res.success) {
                            this.rewardLevelAndCredit()
                        } else {
                            this.$alert.show(res.errMsg)
                        }
                    })
                    .catch(err => {
                        this.$loading.hide()
                        this.$alert.show(err)
                    })
            },
            async getUserInfo (token) {
                const { errMsg, data, success } = await api.user.userEditInfo(token)
                if (success) {
                    return data
                } else {
                    window.console.log(errMsg)
                }
            },
            async getPinYin (name) {
                try {
                    const { data, success } = await api.page.getPinyin(name)
                    if (success) {
                        return data
                    }
                } catch (error) {
                    console.log(error)
                }
                return ""
            },
            async subEditInfo () {
              console.log("subEditInfo")
                return await api.user.subEditInfo({
                    userName: this.token,
                    FirstName: this.userInfo.firstName,
                    LastName: this.userInfo.lastName,
                    FirstNamePinYin: this.userInfo.firstNamePinYin,
                    LastNamePinYin: this.userInfo.lastNamePinYin,
                    Gender: this.userInfo.gender,
                    DateOfBirth: this.userInfo.dateOfBirthStr,
                    Nationality: this.userInfo.nationality,
                    Email: this.userInfo.email,
                    UpdateFields: this.updateFields,
                    MarketingFlagEmail:this.userInfo.marketingFlagEmail
                })
            },
            // 积分里程回溯接口
            async rewardLevelAndCredit (infoIntegrity) {
                this.$loading.show()
                await api.user.memberUpdateLevelAndCredit()
                this.$loading.hide()
                let self = this
                if (infoIntegrity < 100) {
                    this.$alert.show('恭喜您获得200积分', {
                        confirmCallBack: () => {
                            self.goBack()
                        }
                    })
                } else {
                    this.$alert.show('提交成功', {
                        confirmCallBack: () => {
                            self.goBack()
                        }
                    })
                }
            },
            goBack () {
                const query = this.$router.currentRoute.query;
                if (query && query.returnUrl && query.returnUrl.length > 0) {
                    location.href = query.returnUrl
                } else if (query && query.enterType && query.enterType.length > 0 && query.enterType === 'menu') {
                  // 进入类型：菜单
                  this.isShowEditor = false;
                  this.init();
                } else {
                    location.href = `/Rccl.Campaign/MemberCenter/Auth?redirectUrl=${encodeURIComponent(`${process.env.VUE_APP_REWARD_URL}/rewardpc/member/index`)}`
                }
            },
          reload() {
            this.init();
          },
          txtFocus(e) {
            let dataKey = e.target.getAttribute('data-key')
            if (this.isMaskValue) {
              if(dataKey === 'LastName' || dataKey === 'LastNamePinYin') {
                if(!this.updateFields.includes("LastName") || !this.updateFields.includes("LastNamePinYin")) {
                  this.userInfo.lastName = "";
                  this.userInfo.lastNamePinYin = "";
                  this.updateFields.push("LastName");
                  this.updateFields.push("LastNamePinYin");
                }
              }

              if (dataKey === 'FirstName' || dataKey === 'FirstNamePinYin') {
                if(!this.updateFields.includes("FirstName") || !this.updateFields.includes("FirstNamePinYin")) {
                  this.userInfo.firstName = "";
                  this.userInfo.firstNamePinYin = "";
                  this.updateFields.push("FirstName");
                  this.updateFields.push("FirstNamePinYin");
                }
              }

              if(dataKey === 'DateOfBirth') {
                if(!this.updateFields.includes("DateOfBirth")) {
                  this.userInfo.dateOfBirthStr = "";
                  this.updateFields.push("DateOfBirth");
                }
              }

              if(!this.updateFields.includes(dataKey)) {
                Object.keys(this.userInfo).filter(r => {
                  if (dataKey.toUpperCase() === r.toUpperCase()) {
                    this.userInfo[r] = "";
                    return r
                  }
                });
              }
            }

            if(!this.updateFields.includes(dataKey)) {
              this.updateFields.push(dataKey);
            }
          },
          marketingFlagEmailChange() {
              this.userInfo.marketingFlagEmail = !this.userInfo.marketingFlagEmail;
              if(!this.updateFields.includes("MarketingFlagEmail")) {
                this.updateFields.push("MarketingFlagEmail");
              }
          }
        }
    }
</script>

<style lang="less" scoped>
    .personal-center-header {
      height: 36px;
      overflow: hidden;
      margin-top: 13px;
      margin-bottom: 13px;
      & > h3 {
        float: left;
        line-height: 36px;
        margin: 0;
      }
      & > p {
        float: left;
        margin-left: 12px;
        padding-top: 8px;
      }
    }
    .privacy-layout {
      position: absolute;
      top: 30px;
      right: 15px;
      &.is-left {
        left: 130px;
        right: auto;
      }
    }
    .calender-container {
        position: relative;
        top: -34px;
    }

    /************************基本信息（姓名等）************************/
    .personalCenter__knownInfo {
        width: 100%;
        position: relative;
    }

    .personalCenter__content_Detailinfo {
        padding: 10px 0;
        //background: #fffefb;
    }

    .personalCenter__content_Detailinfo .personalCenter__input__row {
        position: relative;
        padding-top: 15px;
    }

    .personalCenter__content_Detailinfo .personalCenter__input__row .input__row_container {
        position: relative;
        width: 40%;
        display: inline-block;
        padding-left: 0%;
    }



    .personalCenter__content_Detailinfo .personalCenter__input__row .input__row_container input {
        font-size: 14px;
        margin-bottom: 12px;
        text-indent: 6px;
        height: 38px;
        line-height: 38px;
        font-style: normal;
        color: #282b2c;
    }

    .personalCenter__content_Detailinfo .personalCenter__input__row .input__row_container .input__row_twoEle {
        width: 46%;
        display: inline-block;
        position: relative;
    }

    .personalCenter__content_Detailinfo .personalCenter__input__row .div--verticalLine {
        position: absolute;
        display: inline-block;
        display: none;
        top: 35px;
        margin-right: 10px;
        width: 1px;
        height: 35px;
        background-color: #f5ecd0;
    }

    .personalCenter__readonlyInfo input {
        width: 90%;
        border: none;
        height: 50px;
        line-height: 50px;
        background: #fffefb;
    }

    /************************编辑资料按钮************************/
    .personalCenter__button_editBtn {
        width: 100%;
        text-align: center;
        margin-top: 42px;
        margin-bottom: 29px;
    }

    .personalCenter__button_editBtn button {
        padding: 18px 110px;
        color: #000;
        font-size: 16px;
        background: #fbc300;
    }

    .personalCenter__knownInfo .service {
        text-align: center;
        margin-top: -12px;
        font-size: 16px;
    }

    /************************编辑资料************************/
    .personalCenter__editInfo {
        position: relative;
        margin-right: 20px;
    }

    .personalCenter__editInfo .personalCenter__editInfo_button {
        width: 100%;
        text-align: center;
        margin-top: 41px;
        font-size: 16px;
    }

    .personalCenter__editInfo .personalCenter__editInfo_button .personalCenter__button_saveBtn,
    .personalCenter__editInfo_button .personalCenter__button_editBtn {
        margin-right: 18px;
        display: inline-block;
    }

    .personalCenter__editInfo .personalCenter__editInfo_button .personalCenter__button_cancelBtn {
        display: inline-block;
        margin-right: 15px;
    }

    .personalCenter__editInfo .personalCenter__editInfo_button .personalCenter__button_saveBtn button,
    .personalCenter__editInfo_button .personalCenter__button_editBtn button {
        padding: 5px 25px;
        background: #0269b9;
        color: #fff;
        cursor: pointer;
    }

    .personalCenter__editInfo .personalCenter__editInfo_button .personalCenter__button_cancelBtn button {
        padding: 5px 25px;
        background: #fff;
        color: #585858;
        border: 1px #dadada solid;
        cursor: pointer;
    }

    .personalCenter__content_editInfo input {
        width: 220px;
        border: none;
        border-bottom: 1px solid #dadada;
        background: #fff;
        line-height: 38px;
    }

    .personalCenter__content_editInfo select {
        height: 34px;
        line-height: 34px;
        border: 1px solid #e5e5e5;
        background: #fff;
        font-size: 14px;
        margin-bottom: 12px;
        outline: none;
    }

    .personalCenter__content_editInfo .select__month, .personalCenter__content_editInfo .select__day {
        width: 23.71%;
    }

    .personalCenter__content_editInfo .select__province, .personalCenter__content_editInfo .select__city {
        /*width: 38.5%;*/
        width: 46.3%;
        height: 40px;
        line-height: 40px;
    }

    .personalCenter__content_editInfo .editInfo_applyForVip {
        padding: 10px 26px;
        background: #fab300;
        font-size: 14px;
        border-radius: 4px;
        margin-bottom: 9px;
        vertical-align: middle;
    }

    .personal_canEdit {
        color: #0072ff;
        border-bottom: solid 1px;
        cursor: pointer;
        text-decoration: none;
    }

    .personalCenter--login {
        color: #031257;
        font-weight: 600;
        font-size: 18px;
    }

    .personalCenter_bindLoyalty {
        background-color: #021156;
        width: 100px;
        font-size: 16px;
        color: white;
        margin: 10px;
        border-radius: 15px;
    }

    /* 改版样式 */
    #layout-main-container .personal_center .center_right .center_conten {
        height: 827px;
        margin-bottom: 0px;
        background-color: #fff;
    }
    .personalCenter__editInfo  h3 {
        margin-left: 20px;
        color: #282b2c;
    }
    .txtCon {
        display: inline-block;
        width: 80px;
        text-align: right;
        margin-right: 10px;
    }

    .inputCon {
        position: relative;
        display: inline-block;
        margin-left: 5px;
    }

    .inputCon span {
        color: #282b2c;
        font-weight: 500;
    }

    .inputCon input:focus {
        border-color: #53a3e1;
    }

    .sex {
        position: relative;
        width: 36px;
        margin-left: 3px;
    }

    .customRadioContainer input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }
    .inputCon label {
        width: 42px;
        text-align: right;
        margin-right: 20px;
    }
    .customRadioContainer {
        position: relative;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }
    .customRadioContainer .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 18px;
        width: 18px;
        background-color: white;
        border: solid 1px #d3dadd;
        border-radius: 50%;
    }
    .customRadioContainer .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    .customRadioContainer input:checked ~ .checkmark:after {
        display: block;
    }
    .customRadioContainer .checkmark:after {
        top: 4px;
        left: 4px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #0073bb;
    }

    /************************ 国籍 ************************/
    #countrySelCon {
        overflow: hidden;
        overflow-y: scroll;
        width: 260px;
        height: 400px;
        background-color: #fff;
        border-radius: 3px;
        box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.1);
        border: 1px #AFC8E0 solid;
        position: absolute;
        top: 58px;
        left: 43px;
        z-index: 9999;
    }

    #countrySelCon a {
        width: 100%;
        height: 30px;
        line-height: 30px;
        font-weight: bold;
        font-size: 14px;
        text-align: center;
        display: inline-block;
        cursor: pointer;
    }

    #countrySelCon a:hover {
        background: #041555;
        color: #fff;
        text-decoration: none;
    }

    .no-bc {
      border: none !important;
    }

    .form-footer-box {
      margin-left: 36px;
    }
    .chk-box {
      display: flex;
      align-items: center;
      font-size: 12px;
      cursor: default;
      color: #000;
      & .is-important {
        color: #FF0004;
      }
    }

    .improvePointsPromptsBar {
      display: flex;
      gap: 0 4px;
      align-items: center;
      margin-top: 20px;
      & .promptsIcon {
        display: flex;
        width: 15px;
        height: 15px;
      }
      & .promptsText {
        height: 15px;
        font-size: 12px;
        line-height: 15px;
        color: #9A9A9A;
        & .txt {
          color: #FFB900;
        }
      }
    }
</style>
